<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__productpage}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:productpage:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:productpage:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="ID" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="productId" label="产品名称" header-align="center" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ getDictLabel(scope.row.productId) }}
          </template>
        </el-table-column>
        <el-table-column prop="domain" label="域名" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>    
        <el-table-column prop="url" label="URL" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="xpath1" label="xpath1" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="xpath2" label="xpath2" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="status" label="状态：1启用 0禁用" header-align="center" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div>
              <el-tag v-if="scope.row.status == 1" size="small">启用</el-tag>
              <el-tag v-if="scope.row.status == 0" size="small" type="danger">禁用</el-tag>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="creator" label="创建人" header-align="center" align="center"></el-table-column> -->
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <!-- <el-table-column prop="updateBy" label="更新人" header-align="center" align="center"></el-table-column> -->
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:productpage:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:productpage:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './productpage-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/productpage/page',
        getDataListIsPage: true,
        exportURL: '/sys/productpage/export',
        deleteURL: '/sys/productpage',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      },
      productList:[],
    }
  },
  components: {
    AddOrUpdate
  },
  created() {
    this.getProductList()
  },
  methods:{
    getDictLabel(value) {
      const dictItem = this.productList.find(item => item.value === value);
      return dictItem ? dictItem.label : ''; // 返回对应的 label 或空字符串
    },
    // 产品名称列表
    async getProductList() {
      this.$http.get(`sys/slproduct/page?order=&orderField=&page=1&limit=500`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        if (res.data!=null){
          res.data.list.forEach(element => {
            this.productList.push({label:element.productName,value:element.id})
          })
        }
      }).catch(() => {})
    },
  }
}
</script>
